<div *ngIf="isInitialized" class="panel panel-default">
  <!-- Payment methods dropdown -->
  <div class="form-group" *ngIf="paymentMethods && paymentMethods.length > 0" class="payment-method-dropdown mb-4">
    <div class="custom-select form-group">
      <select
        class="form-select"
        id="paymentMethodList"
        [ngModel]="selectedIndex"
        #paymentMethodDropdown
        (change)="selectPaymentMethod(paymentMethodDropdown.value)"
      >
        <option *ngFor="let p of paymentMethods; let i = index" [value]="i">
          <span *ngIf="!isDirectPayment(p)">
            {{ p | paymentMethod: 'summary' }} ({{ p | paymentMethod: 'expiryShort' }})
          </span>
          <span *ngIf="isDirectPayment(p)">{{ 'PAY_IN_SHOP' | translate }}</span>
        </option>
        <option [value]="paymentMethods.length">&lt;{{ 'NEW_PAYMENT_METHOD' | translate }}&gt;</option>
      </select>
    </div>
    <hr *ngIf="isLegacyMode" />
  </div>

  <!-- Legacy text -->
  <div *ngIf="isLegacyMode">
    <div class="form-group" *ngIf="isDirectPaymentSelected && !isPaymentCardFormVisible">
      <strong class="text-warning">{{ 'WHEN_PICKING_UP_YOUR_BAGS' | translate }}</strong>
      {{ 'CHECK_OUT_AND_SHOW_RECEIPT' | translate }}.
    </div>

    <div class="form-group" *ngIf="!isDirectPaymentSelected || isPaymentCardFormVisible">
      <div *ngIf="!isPaymentCardFormVisible">
        <strong>{{ 'YOURE_ALL_SET' | translate }}</strong> {{ 'PAYMENT_CHARGED_AUTOMATICALLY' | translate }}.
      </div>
      <div *ngIf="isPaymentCardFormVisible">
        <span *ngIf="isPaymentDue">
          {{ 'ENTER_CARD_DETAILS' | translate }} {{ 'AND' | translate }} {{ 'CHOOSE' | translate }} '{{
            'ADD_PAYMENT_CARD' | translate
          }}' {{ 'WHEN_YOURE_DONE' | translate }}.
        </span>
        <span *ngIf="!isPaymentDue">
          <strong class="text-warning">{{ 'NO_PAYMENT_AT_THIS_STEP' | translate }}</strong>
          {{ 'YOU_ONLY_PAY_IF_YOU_SHOW_UP' | translate }}
        </span>
      </div>
    </div>
  </div>

  <!-- Browser payment -->
  <div *ngIf="isBrowserPaymentAvailable && isPaymentCardFormVisible" class="pb-1 mb-2">
    <!-- Apple Pay -->
    <a id="applePay" class="btn btn-block btn-apple" (click)="showBrowserPayment()" *ngIf="isApplePayAvailable"> </a>

    <!-- Google Pay -->
    <a id="googlePay" class="btn btn-block btn-google" (click)="showBrowserPayment()" *ngIf="isGooglePayAvailable">
      <i>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          role="presentation"
          fill="#A1A1A1"
          class="main-header__logo-image"
          viewBox="0 0 435.97 173.13"
        >
          <path
            d="M206.2,84.58v50.75H190.1V10h42.7a38.61,38.61,0,0,1,27.65,10.85A34.88,34.88,0,0,1,272,47.3a34.72,34.72,0,0,1-11.55,26.6q-11.2,10.68-27.65,10.67H206.2Zm0-59.15V69.18h27a21.28,21.28,0,0,0,15.93-6.48,21.36,21.36,0,0,0,0-30.63,21,21,0,0,0-15.93-6.65h-27Z"
            fill="#fff"
          />
          <path
            d="M309.1,46.78q17.85,0,28.18,9.54T347.6,82.48v52.85H332.2v-11.9h-.7q-10,14.7-26.6,14.7-14.17,0-23.71-8.4a26.82,26.82,0,0,1-9.54-21q0-13.31,10.06-21.17t26.86-7.88q14.34,0,23.62,5.25V81.25A18.33,18.33,0,0,0,325.54,67,22.8,22.8,0,0,0,310,61.13q-13.49,0-21.35,11.38l-14.18-8.93Q286.17,46.78,309.1,46.78Zm-20.83,62.3a12.86,12.86,0,0,0,5.34,10.5,19.64,19.64,0,0,0,12.51,4.2,25.67,25.67,0,0,0,18.11-7.52q8-7.53,8-17.67-7.53-6-21-6-9.81,0-16.36,4.73C290.46,100.52,288.27,104.41,288.27,109.08Z"
            fill="#fff"
          />
          <path
            d="M436,49.58,382.24,173.13H365.62l19.95-43.23L350.22,49.58h17.5l25.55,61.6h.35l24.85-61.6Z"
            fill="#fff"
          />
          <path
            d="M141.14,73.64A85.79,85.79,0,0,0,139.9,59H72V86.73h38.89a33.33,33.33,0,0,1-14.38,21.88v18h23.21C133.31,114.08,141.14,95.55,141.14,73.64Z"
            fill="#4285f4"
          />
          <path
            d="M72,144c19.43,0,35.79-6.38,47.72-17.38l-23.21-18C90.05,113,81.73,115.5,72,115.5c-18.78,0-34.72-12.66-40.42-29.72H7.67v18.55A72,72,0,0,0,72,144Z"
            fill="#34a853"
          />
          <path d="M31.58,85.78a43.14,43.14,0,0,1,0-27.56V39.67H7.67a72,72,0,0,0,0,64.66Z" fill="#fbbc04" />
          <path
            d="M72,28.5A39.09,39.09,0,0,1,99.62,39.3h0l20.55-20.55A69.18,69.18,0,0,0,72,0,72,72,0,0,0,7.67,39.67L31.58,58.22C37.28,41.16,53.22,28.5,72,28.5Z"
            fill="#ea4335"
          />
        </svg>
      </i>
    </a>
  </div>

  <div *ngIf="isPayPalPaymentVisible && isPaymentCardFormVisible" class="mb-2">
    <lh-paypal-button (click)="onPaypalClick($event)"></lh-paypal-button>
  </div>

  <!-- Payment card form -->
  <div class="form-group" *ngIf="isPaymentCardFormVisible">
    <div class="divider">
      <small class="divider-text">{{ 'OR' | translate | lowercase }}</small>
    </div>
    <lh-payment-card-input
      [isLoading]="isLoading"
      [storageLocationId]="storageLocationId"
      [orderId]="orderId"
      [bookingId]="bookingId"
      [allowCancel]="false"
      [showCardBrands]="false"
      [payment]="payment"
      (result)="onPaymentCardResult($event)"
      (cancel)="cancelAddPaymentCard()"
    ></lh-payment-card-input>
  </div>

  <!-- Direct payment info -->
  <div class="form-group" *ngIf="isDirectPaymentSelected && !isPaymentCardFormVisible">
    <small>{{ 'YOU_CAN_PAY_THE_STAFF_DIRECTLY' | translate }}.</small>
  </div>
</div>

<div class="spinner-container" *ngIf="!isInitialized || isInitiatingPayment">
  <lh-shared-ui-spinner [visible]="true"></lh-shared-ui-spinner>
</div>
